import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./style/navigation.css";

const Leftnavigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeItem, setActiveItem] = useState(""); // Track the active menu item
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  const menuRefs = useRef({}); // To store references to each menu item

  // Automatically set the active menu item based on the current route
  useEffect(() => {
    setActiveItem(location.pathname);
    if (menuRefs.current[location.pathname]) {
      menuRefs.current[location.pathname].scrollIntoView({
        behavior: "smooth",
        inline: "start",
      });
    }
  }, [location]);

  // Handle scroll event
  const handleScroll = () => {
    const offset = window.scrollY;
    setIsScrolled(offset > 0);
  };

  // Attach scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handle menu item click
  const handleItemClick = (route) => {
    navigate(route);
    setActiveItem(route); // Set the clicked route as active
    if (menuRefs.current[route]) {
      menuRefs.current[route].scrollIntoView({
        behavior: "smooth",
        inline: "center",
      });
    }
  };

  // Logout handler
  const handleLogout = () => {
    sessionStorage.removeItem("username");
    navigate("/Admin");
  };

  return (
    <div className={`left-navigation ${isScrolled ? "scrolled" : ""}`}>
      <ul className="menu">
        {[
          { route: "/AdminDashboard", label: "Dashboard" },
          { route: "/News", label: "News" },
          { route: "/Collage", label: "Collage Programs" },
          { route: "/Generaldeptevents", label: "General department Events" },
          { route: "/Cmedeptevents", label: "Computer Science Engineering Events" },
          { route: "/Ecedeptevents", label: "Electronics and Communication Engineering Events" },
          { route: "/Eeedeptevents", label: "Electrical and Electronics Engineering Events" },
          { route: "/Mechdeptevents", label: "Mechanical Engineering Events" },
          { route: "/Generaldepartment", label: "Generaldepartment" },
          { route: "/Cmedepartment", label: "Computer department" },
          { route: "/Eeedepartment", label: "Electrical And Electronics department" },
          { route: "/Ecedepartment", label: "Electronics and Communication Engineering department" },
          { route: "/Mechdepartment", label: "Mechanical Engineering department" },
          { route: "/Principal", label: "Principal Details" },
          { route: "/Adminhostel", label: "Hostel" },
          { route: "/AdminAcadamics", label: "Academics" },
          { route: "/Contactform", label: "Contact Form" },
          { route: "/Studentdetails", label: "Student Details" },
          { route: "/Departmentlogininfo", label: "Login Details" },
        ].map((menu) => (
          <li
            key={menu.route}
            id="li"
            ref={(el) => (menuRefs.current[menu.route] = el)} // Store ref
            className={activeItem === menu.route ? "active" : ""}
            onClick={() => handleItemClick(menu.route)}
          >
            {menu.label}
          </li>
        ))}
        <li
          id="li"
          className="logout"
          onClick={handleLogout}
          style={{ background: "red" }}
        >
          Logout
        </li>
      </ul>
    </div>
  );
};

export default Leftnavigation;
